export enum INVOICE_STATUS {
  PAID = 'paid',
  UNPAID = 'payment_requested',
}

export enum INVOICE_STATUS_LABELS {
  PAID = 'Paid',
  UNPAID = 'Unpaid',
}

export const INVOICE_STATUS_OPTIONS = [
  { value: INVOICE_STATUS.PAID, label: INVOICE_STATUS_LABELS.PAID },
  { value: INVOICE_STATUS.UNPAID, label: INVOICE_STATUS_LABELS.UNPAID },
];
